export default __webpack_public_path__ + "static/media/area-57.aa01773f.jpg";